// extracted by mini-css-extract-plugin
module.exports = {"history":"styles_history__MZgvO","card":"styles_card__3S0ev","time":"styles_time__3dVct"};